/**
 * 取消预约：打开后拉取 GET /project-plan/member-project/{id}，表格内按安排 ID 调用取消接口
 */
import React from 'react'
import PropTypes from 'prop-types'
import WrappedModal from '@/components/WrappedModal'
import CancelMemberProjectPlansForm from './CancelMemberProjectPlansForm'

class CancelMemberProjectPlansModal extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    memberProjectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    projectName: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    onSuccess: PropTypes.func
  }

  render() {
    const { children, memberProjectId, projectName, dispatch, onSuccess } = this.props
    const title = projectName ? `取消预约 · ${projectName}` : '取消预约'
    return (
      <WrappedModal
        title={title}
        baseComponent={<CancelMemberProjectPlansForm />}
        baseProps={{ memberProjectId, dispatch, onSuccess }}
        footer={null}
        width={1000}
        maskClosable
        destroyOnClose
      >
        {children}
      </WrappedModal>
    )
  }
}

export default CancelMemberProjectPlansModal
